import { ROUTES } from '@/shared/routes';

export const NAV_ROUTES = {
  overview: ROUTES.leasing,
  requests: ROUTES.leasingRequests,
  contracts: ROUTES.leasingContract,
  appeals: ROUTES.leasingAppeals
  // services: ROUTES.leasingServices
} as const;

export type TNavId = keyof typeof NAV_ROUTES;

// label — ключ перевода, резолвится через t() в месте рендера (sidebar-nav)
export const NAV: Array<{ id: TNavId; label: string }> = [
  { id: 'overview', label: 'layout.nav.overview' },
  { id: 'requests', label: 'layout.nav.requests' },
  { id: 'contracts', label: 'layout.nav.contracts' },
  { id: 'appeals', label: 'layout.nav.appeals' }
  // { id: 'services', label: 'layout.nav.services' }
];

export const MOBILE_BOTTOM_NAV_IDS: TNavId[] = ['overview', 'requests'];
